<template>
  <div>
    <QueryFrame
      :addText="handlePermission('stocktakingPlanAdd') ?'新建盘点计划':''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="handleStocktakingPlanAdd"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>盘点单搜索:</label>
          <lk-input class="item" placeholder="支持盘点单号，盘点计划名称" v-model="query.serialNumber"></lk-input>
        </div>
        <div class="queryItem">
          <label>盘点仓库:</label>
          <lk-select class="item" filterable multiple clearable v-model.trim="query.warehouseIds" placeholder="请选择">
            <lk-option v-for="item in warehouseList" :key="item.id" :value="item.id">
              {{item.warehouseName}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点类型:</label>
          <lk-select class="item" multiple clearable v-model.trim="query.operatorTypes" placeholder="请选择">
            <lk-option v-for="item in operatorTypeList" :key="item.id" :value="item.id">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点方式:</label>
          <lk-select class="item" clearable v-model.trim="query.operatorPattern" placeholder="请选择">
            <lk-option v-for="item in operatorPatternsList" :key="item.id" :value="item.id">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>是否含0在库数量商品:</label>
          <lk-select class="item" clearable v-model.trim="query.hasZero" placeholder="请选择">
            <lk-option v-for="(item, index) in hasZeroList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点进度:</label>
          <lk-select class="item" clearable v-model.trim="query.status" placeholder="请选择">
            <lk-option v-for="(item, index) in statusList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点调整进度:</label>
          <lk-select class="item" clearable v-model.trim="query.adjustStatus" placeholder="请选择">
            <lk-option v-for="item in adjustStatusList" :value="item.id" :key="item.id">{{ item.name }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>创建人员:</label>
          <lk-select class="item" filterable clearable v-model.trim="query.createUserId" placeholder="请选择">
            <lk-option v-for="item in creatUserList" :value="item.createUserId" :key="item.createUserId">{{ item.createUserName }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>创建时间:</label>
          <timeStampDatePicker 
            type='daterange' 
            placeholder='请选择' 
            class="item" 
            v-model="query.createTimeRange"
            @on-change='handleCreateTimeChange'
            :options="disabledDateFuture"
          ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>盘点人员:</label>
          <lk-select 
            class="item" 
            clearable 
            filterable
            remote
            :loading='loading'
            label-in-value
            :remote-method="toSearchOperator"
            v-model.trim="query.operatorId" 
            placeholder="请选择"
          >
            <lk-option v-for="(item, index) in operatorListPart" :value="item.id" :key="item.id" :label='item.name'>{{ item.name }}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点时间:</label>
          <timeStampDatePicker 
            type='daterange' 
            placeholder='请选择' 
            class="item"
            @on-change='handleOpeTimeChange'
            v-model="query.operatorTimeRange"
          ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 打印盘点信息 开始 -->
    <section id="printArea" ref="print" class="stocktaking-print-area">
      <div>
        <strong>盘点单号:{{stocktakingInfo.serialNumber}}</strong><br/>
        <span class="mr32">盘点计划名称:{{stocktakingInfo.name}}</span>
        <span class="mr32">盘点仓库:{{stocktakingInfo.warehouseNames}}</span>
        <span class="mr32">是否含0库存商品:{{stocktakingInfo.hasZeroStr}}</span>
        <span class="mr32">盘点人员:{{stocktakingInfo.allOperatorName}}</span>
      </div>
      <table class="print-table">
        <thead>
          <th style="width: 30px;">序号</th>
          <th style="width: 70px;">门店名称</th>
          <th style="width: 70px;">商品编码</th>
          <th style="width: 80px;">药品通用名</th>
          <th style="width: 60px;">商品名</th>
          <th style="width: 45px;">规格</th>
          <th style="width: 45px;">来源</th>
          <th style="width: 50px;">生产企业</th>
          <th style="width: 30px;">单位</th>
          <th style="width: 50px;">仓库</th>
          <th style="width: 45px;">批号</th>
          <th style="width: 45px;">有效期</th>
          <th style="width: 45px;">盘点人员</th>
          <th style="width: 40px;">在库数量</th>
          <th style="width: 40px;">实盘数量</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in printData" :key="index">
            <td><span style="width: 30px;">{{index + 1}}</span></td>
            <td><span style="width: 70px;">{{item.storeName}}</span></td>
            <td><span style="width: 70px;">{{item.drugSerialCode}}</span></td>
            <td><span style="width: 80px;">{{item.approvedDrugNames}}</span></td>
            <td><span style="width: 60px;">{{item.goodsName}}</span></td>
            <td><span style="width: 45px;">{{item.specifications}}</span></td>
            <td><span style="width: 45px;">{{item.purchaseType}}</span></td>
            <td><span style="width: 50px;">{{item.producer}}</span></td>
            <td><span style="width: 40px;">{{item.drugMiniPackageUnit}}</span></td>
            <td><span style="width: 50px;">{{item.warehouseName}}</span></td>
            <td><span style="width: 45px;">{{item.goodsBatchNumber}}</span></td>
            <td><span style="width: 50px;">{{item.expiryDate}}</span></td>
            <td><span style="width: 45px;">{{item.operatorName}}</span></td>
            <td><span style="width: 40px;">{{item.inInventoryCount}}</span></td>
            <td><span style="width: 40px;">&nbsp;</span></td>
          </tr>
        </tbody>
      </table>

    </section>
    <!-- 打印盘点信息 结束 -->
    <lk-modal
      v-model="isShowModalChangeOpeator"
      title='修改盘点人员'
      :footer-hide="true"
      :closable="false"
    >
      <div style="display:flex;align-items:center;justify-content:center;">
        <label>盘点人员：</label>
        <lk-select 
          style="width:300px;"
          clearable
          multiple
          filterable
          v-model.trim="modalChangeOperator.operatorIdLists"
          placeholder="请选择"
        >
          <lk-option v-for="(item, index) in operatorListUpdate" :value="item.id" :key="item.id" :label='item.name'>{{ item.name }}</lk-option>
        </lk-select>
      </div>
      <div style="display:flex;justify-content:right;margin:20px 60px 0 0;">
          <lk-button type='primary' @click="toSave" :loading="updateLoading">保存</lk-button>
          <lk-button style="margin-left:16px;" @click="toCancel">取消</lk-button>
        </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import sharedData from '../../libs/sharedDara';

export default {
  name: 'stocktakingPlan',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      disabledDate: {
        disabledDate (date) {
          if ( date > Date.now()) {
            return date && date.valueOf() > Date.now() + 7776000000
          } else {
            return date && date.valueOf() < Date.now() - 86400000
          }
        }
      },
      disabledDateFuture: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now()
        }
      },
      isShowModalChangeOpeator: false,
      modalChangeOperator: {
        operatorIdLists: [],
        id: null,
      },
      loading: false,
      operatorListPart: [],
      creatUserList: [],
      operatorTypeList: [], // 盘点类型
      operatorPatternsList: [], // 盘点方式
      adjustStatusList: [
        {
          id: 1,
          name: '未调整'
        },
        {
          id: 2,
          name: '全部调整'
        },
        {
          id: 3,
          name: '无需调整'
        },
        {
          id: 4,
          name: '调整中'
        },
        {
          id: 5,
          name: '部分调整'
        },
      ], // 盘点调整进度
      createUserNameList: [],
      warehouseList: [],
      hasZeroList: new Map().set(1, '是').set(2, '否'),
      statusList: new Map([
        [1, '盘点未开始'],
        [2, '初盘待完成'],
        [3, '初盘已完成'],
        [4, '复盘待完成'],
        [5, '已取消'],
        [6, '复盘已完成'],
        [7, '已完成']
      ]),
      query: {
        storeIdList: [],
        warehouseIds: [],
        hasZero: null,
        status: null,
        operatorTypes: [], // 盘点类型
        operatorPattern: null, // 盘点方式
        status: null, // 盘点进度
        adjustStatus: null, // 盘点调整进度
        createUserId: null, // 创建人员
        createTimeRange: null, // 创建时间
        operatorId: null, // 盘点人员
        operatorTimeRange: null, // 盘点时间
      },
      tableData: [],
      stocktakingInfo: {},
      adjustStatusMap: new Map([
        [1, '未调整'],
        [2, '全部调整'],
        [3, '无需调整'],
        [4, '调整中'],
        [5, '部分调整']
      ]),
      columns: [
        {
          title: '盘点单号',
          key: 'serialNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点计划名称',
          key: 'name',
          minWidth: 130,
          tooltip: true,
        },
        {
          title: '盘点仓库',
          key: 'warehouseNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点类型',
          key: 'operatorType',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点方式',
          key: 'operatorPattern',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '是否含0在库数量商品',
          key: 'hasZero',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '创建人员',
          key: 'createUserName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点人员',
          key: 'operatorName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点时间',
          key: 'operatorTime',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点调整',
          key: 'adjustStatusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '操作',
          minWidth: 160,
          render: (h, { row }) => {
            //盘点未开始 1;初盘待完成 2;初盘已完成 3;复盘待完成 4;复盘已完成: 3; 取消: 5
            let btnList = [];
            const logInBtn = h('lk-tooltip', { // 录入按钮
              props: {
                content: '录入盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'stocktakingRecord',
                      params: { id: row.id, status: row.status },
                    });
                  },
                },
              }, '录入')
            ])
            const printBtn = h('lk-tooltip', { // 打印按钮
              props: {
                content: '打印盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.handlePrintPlan(row);
                  },
                },
              }, '打印')
            ])
            const viewBtn = h('lk-tooltip', { // 查看按钮
              props: {
                content: '查看盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'stocktakingRecordView',
                      params: { id: row.id, status: row.status },
                    });
                  },
                },
              }, '查看')
            ])
            const adjustBtn = h('lk-tooltip', { // 调整按钮
              props: {
                content: '调整盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    if ([3, 6].includes(row.status) && row.hasNoDealNum === 1) {
                      const id = row.id;
                      this.$router.push({
                        name: 'stocktakingProfitAndLossAdd',
                        params: { id },
                      });
                    } else {
                      this.$Message.error('当前状态不支持创建盘点损溢');
                    }
                  },
                },
              }, '调整')
            ])
            const exportBtn = h('lk-tooltip', { // 导出按钮
              props: {
                content: '导出盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    inventory.stocktakingRecordDownload({ stocktakingPlanId: row.id, status: row.status })
                      .then((res) => {
                        utils.downLoadExcel(res, `库存盘点${row.serialNumber}-`);
                      })
                      .catch((err) => {
                        utils.handleError(err);
                      });
                  },
                },
              }, '导出')
            ])
            const cancelBtn = h('lk-button', { // 取消按钮
              props: {
                type: 'text',
                disabled: row.isForbid === 1,
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否取消该盘点计划？</p>',
                    onOk: () => {
                      inventory.stocktakingRecordCancel({ stocktakingPlanId: row.id }).then(res => {
                        if (res.data.status === 200) {
                          this.$Message.success('取消成功');
                          this.getData();
                        } else {
                          this.$Message.error(res.data.error);
                        }
                      }).catch(err => {
                        utils.handleError(err);
                      })
                    }
                  })
                }
              }
            }, '取消') // 取消
            const changeOperatorBtn = h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.modalChangeOperator.operatorIdLists = [];
                  this.isShowModalChangeOpeator = true;
                  this.modalChangeOperator.id = row.id;
                }
              }
            }, '修改盘点人员');
            //盘点未开始 1;初盘待完成 2;初盘已完成 3;复盘待完成 4;复盘已完成: 3; 取消: 5;
            // 初盘待完成和复盘待完成展示录入和打印按钮
            if ([2, 4].includes(row.status) && this.handlePermission('stocktakingRecord')) {
              btnList.push(logInBtn, printBtn);
            }
            // 初盘已完成，复盘待完成，复盘已完成展示查看按钮
            if ([3, 4, 6, 7].includes(row.status) && this.handlePermission('stocktakingRecordView')) {
              btnList.push(viewBtn);
            }
            // 初盘待完成，初盘已完成，复盘待完成，复盘已完成展示导出按钮
            if ([2, 3, 4, 6, 7].includes(row.status) && this.handlePermission('stocktakingRecordExport')) {
              btnList.push(exportBtn);
            }
            // 复盘已完成展示调整按钮
            if ([3, 6].includes(row.status) && row.hasNoDealNum === 1 && row.adjustStatus != 3 && this.handlePermission('stocktakingProfitAndLossAdd')) {
              btnList.push(adjustBtn);
            }
            // 盘点未开始，初盘待完成展示取消按钮
            if ([1, 2].includes(row.status)) {
              btnList.push(cancelBtn);
            }
            // 盘点未开始，初盘待完成展示修改盘点人员按钮
            if([1, 2].includes(row.status) && this.handlePermission('updateCheckOperator')) {
              btnList.push(changeOperatorBtn);
            }
            return h('div', btnList)
          }
        },
      ],
      printData: [],
      operatorListUpdate: [],
      updateLoading: false,
    };
  },
  methods: {
    handleCreateTimeChange(value) {
      if ((value[1] - value[0]) > 7776000000) {
        this.$Message.error('创建时间范围不可大于三个月');
        this.query.createTimeRange = [];
      }
    },
    handleOpeTimeChange(value) {
      if ((value[1] - value[0]) > 7776000000) {
        this.$Message.error('盘点时间范围不可大于三个月');
        this.query.operatorTimeRange = [];
      }
    },
    getWarehouseList() {
      return inventory.warehouseList({
        page: 1,
        size: 100,
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.createTimeRange instanceof Array && this.params.createTimeRange.length) {
        this.params.startCreateTime = this.params.createTimeRange[0];
        this.params.endCreateTime = this.params.createTimeRange[1];
      }
      if (this.params.operatorTimeRange instanceof Array && this.params.operatorTimeRange.length) {
        this.params.startOperatorTime = this.params.operatorTimeRange[0];
        this.params.endOperatorTime = this.params.operatorTimeRange[1];
      }
      this.tableData = [];
      inventory.stocktakingPlanListCondition(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            this.count = count;
            list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              if (result.operatorType) {
                result.operatorType = this.operatorTypeList[result.operatorType - 1].name;
              }
              if (result.operatorPattern) {
                result.operatorPattern = this.operatorPatternsList[result.operatorPattern - 1].name;
              }
              result.createTime = utils.exchangeTime(result.createTime);
              result.operatorTime = utils.formatTime(result.operatorTime);
              result.statusStr = this.statusList.get(result.status);
              result.adjustStatusStr = this.adjustStatusMap.get(result.adjustStatus);
              result.hasZero = this.hasZeroList.get(result.hasZero);
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handlePrintPlan(row) {
      const params = {
        stocktakingPlanId: row.id,
        status: row.status,
        menuSourceType: 2,
      }
      inventory.stocktakingRecordList(params)
        .then((res) => {
          if (res.data.status === 200) {
            const { stocktakingPlan: stocktakingInfo, stocktakingRecords } = res.data.data;
            this.stocktakingInfo = stocktakingInfo;
            this.stocktakingInfo.hasZeroStr = this.hasZeroList.get(this.stocktakingInfo.hasZero);
            this.stocktakingInfo.createTime = utils.exchangeTime(this.stocktakingInfo.createTime);
            if (!this.stocktakingInfo.warehouseNames) {
              this.stocktakingInfo.warehouseNames = '全部';
            }
            stocktakingRecords.forEach((item) => {
              item.amountBeforeTax = item.inventoryNumber * item.priceBeforeTax;
              item.priceWithoutTax = (item.priceBeforeTax / (1 + item.inputTaxRate / 100)).toFixed(6);
              item.amountWithoutTax = (item.inventoryNumber * item.priceWithoutTax).toFixed(6);
              if (item.purchaseType) {
                item.purchaseType = item.purchaseType === 1 ? '普通采购' : '援助药品';
              }
              if (item.expiryDate) {
                item.expiryDate = utils.exchangeTime(item.expiryDate);
              }
              if (this.stocktakingInfo.operatorPattern === 2) { // 暗盘不展示在库数量
                item.inventoryCount = '';
              }
            });
            this.printData = stocktakingRecords;
            this.$nextTick(() => {
              this.$print(this.$refs.print);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleStocktakingPlanAdd() {
      this.$router.push({ name: 'stocktakingPlanAdd' });
    },
    handleReset() {
      this.query = {};
    },
    toSearchOperator(query) {
      if (query !== '') {
        this.loading = true;
        inventory.getOperatorLists({
          isGet: true,
          userName: query
        }).then(res => {
          this.loading = false;
          if (res.data.status === 200) {
            if (res.data.data.length) {
              this.operatorListPart = res.data.data;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch(err => {
          this.loading = false;
          utils.handleError(err);
        })
      }
    },
    getCreatUserList() {
      inventory.getOperatorName().then(res => {
        if (res.data.status === 200) {
          this.creatUserList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    searchOperatorUpdate() {
      inventory.getOperatorLists({
        isGet: false,
      }).then(res => {
        if (res.data.status === 200) {
          if (res.data.data.length) {
            this.operatorListUpdate = res.data.data;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toSave() {
      console.log(this.modalChangeOperator.operatorIdLists)
      if (!this.modalChangeOperator.operatorIdLists.length) {
        this.$Message.error('请先选择盘点人员');
        return
      }
      const params = {
        id: this.modalChangeOperator.id,
        operatorIdLists: this.modalChangeOperator.operatorIdLists,
      }
      this.updateLoading = true;
      inventory.updateOperator(params).then(res => {
        this.updateLoading = false;
        if (res.data.status === 200) {
          this.$Message.success('修改成功');
          this.isShowModalChangeOpeator = false;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        this.updateLoading = false;
        utils.handleError(err);
      })
    },
    toCancel() {
      this.isShowModalChangeOpeator = false;
    },
  },
  created() {
    this.operatorTypeList = sharedData.operatorTypeList;
    this.operatorPatternsList = sharedData.operatorPatternsList;
    this.getCreatUserList();
    this.getWarehouseList();
    this.searchOperatorUpdate();
    this.handleSearch(true);
    if (this.roleType) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
  @media print {
    .stocktaking-print-area {
      display: block;
    }
  }

  @media screen {
    .stocktaking-print-area {
      display: none;
    }
  }

  .mr32 {
    margin-right: 32px
  }

  .print-table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    td,
    th {
      padding: 0 2px;
      border: 1px solid #000;
      color: #000;
    }
    thead {
      th,
      td {
        font-size: 12px;
        font-weight: normal;
        text-align: center;
        color: #000;
      }
    }
    tbody {
      td {
        font-size: 12px;
        text-align: left;
        padding: 0 2px;
        span {
          display: inline-block;
          font-size: 12px;
          word-break: break-all;
          color: #000;
        }
      }
    }
  }
</style>
